import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Header, Segment, Grid, List, Divider, Icon, Button } from 'semantic-ui-react';
import classes from "./FootersPages.module.css";

export default function GettingStarted() {
    const { t } = useTranslation();

    return (
        <Container className={`${classes.gettingStarted}`} style={{ padding: '3em 0em' }}>
            <Segment basic textAlign="center">
                <Header as="h1" style={{ fontSize: '2.5em', color: '#2a2a2a' }}>{t('getting_started.title')}</Header>
                <p style={{ fontSize: '1.33em', color: '#5a5a5a', marginBottom: '2em' }}>
                    {t('getting_started.description')}
                </p>
            </Segment>

            <Divider section />

            <Segment basic>
                <Grid stackable columns={2} verticalAlign="middle" textAlign="center">
                    <Grid.Column width={8}>
                        <Icon name="user plus" size="huge" color="blue" />
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <Header as="h2" style={{ fontSize: '2em', color: '#2a2a2a' }}>{t('getting_started.step1')}</Header>
                        <p style={{ fontSize: '1.2em', color: '#5a5a5a', marginBottom: '1em' }}>
                            {t('getting_started.step1_description')}
                        </p>
                        <Button primary size="large" href="/signup">{t('getting_started.signup')}</Button>
                    </Grid.Column>
                </Grid>
            </Segment>

            <Divider section />

            {/* <Segment basic>
                <Grid stackable columns={2} verticalAlign="middle" textAlign="center">
                    <Grid.Column width={8}>
                        <Header as="h2" style={{ fontSize: '2em', color: '#2a2a2a' }}>{t('getting_started.step2')}</Header>
                        <p style={{ fontSize: '1.2em', color: '#5a5a5a', marginBottom: '1em' }}>
                            {t('getting_started.step2_description')}
                        </p>
                        <Button primary size="large" href="/tutoChooseModel">{t('getting_started.select_model')}</Button>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <Icon name="book" size="huge" color="blue" />
                    </Grid.Column>
                </Grid>
            </Segment>

            <Divider section /> */}

            <Segment basic>
                <Grid stackable columns={2} verticalAlign="middle" textAlign="center">
                    <Grid.Column width={8}>
                        <Header as="h2" style={{ fontSize: '2em', color: '#2a2a2a' }}>{t('getting_started.step2a')}</Header>
                        <p style={{ fontSize: '1.2em', color: '#5a5a5a', marginBottom: '1em' }}>
                            {t('getting_started.step2a_description')}
                        </p>
                        <Button primary size="large" href="/SelectStory">{t('getting_started.select_story')}</Button>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <Icon name="play circle" size="huge" color="blue" />
                    </Grid.Column>
                </Grid>
            </Segment>

            <Divider section />

            <Segment basic>
                <Grid stackable columns={2} verticalAlign="middle" textAlign="center">
                    <Grid.Column width={8}>
                        <Icon name="pencil alternate" size="huge" color="blue" />
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <Header as="h2" style={{ fontSize: '2em', color: '#2a2a2a' }}>{t('getting_started.step2b')}</Header>
                        <p style={{ fontSize: '1.2em', color: '#5a5a5a', marginBottom: '1em' }}>
                            {t('getting_started.step2b_description')}
                        </p>
                        <Button primary size="large" href="/Create/Edit/new">{t('getting_started.create_story')}</Button>
                    </Grid.Column>
                </Grid>
            </Segment>

            <Divider section />

            <Segment basic textAlign="center">
                <Header as="h2" style={{ fontSize: '2em', color: '#2a2a2a' }}>{t('getting_started.connect_with_us')}</Header>
                <p style={{ fontSize: '1.33em', color: '#5a5a5a', marginBottom: '1.5em' }}>
                    {t('getting_started.connect_with_us_description')}
                </p>
                <List horizontal divided link size="large">
                    <List.Item as="a" href="mailto:contact@fablia.fr" style={{ color: '#1e70bf' }}>{t('getting_started.email_us')}</List.Item>
                    <List.Item as="a" href="https://www.instagram.com/fablia_fr" style={{ color: '#1e70bf' }}>Facebook</List.Item>
                    <List.Item as="a" href="https://www.instagram.com/fablia_fr" style={{ color: '#1e70bf' }}>Instagram</List.Item>
                </List>
            </Segment>

            <Divider section />
        </Container>
    );
}